import Loading from '../../components/Loading';
import ClientDisplayGrid from './ClientDisplayGrid';
import { ProjectPrioritiesDto } from '../../api';
import ProjectQueries from './ProjectQueries';
import { useState } from 'react';
import _ from 'lodash';
import {
  getStoredSelection,
  getStoredProxySelection,
} from '../../components/form/react-hook-form-components/FilterStorage';
import FilterOptions, { IFilterOptions } from '../FilterOptions';
import SelectedRoles from '../management/employees/roles/SelectedRoles';

function Client() {
  const storageKeyTeam = 'clientsTeam';
  const storageKeyRoles = 'clientsRoles';
  const storageKeyProxy = 'clientsProxy';

  const [filters, setFilters] = useState<IFilterOptions>({
    team: getStoredSelection(storageKeyTeam),
    roles: getStoredSelection(storageKeyRoles),
    proxy: getStoredProxySelection(storageKeyProxy),
  });

  const { data: projects, isLoading } = ProjectQueries().FetchClientPriorities(
    filters.proxy,
    filters.team?.value,
    undefined,
    SelectedRoles(filters.roles)
  );

  const displayClientPriorityGrid = () => {
    if (isLoading) {
      return <Loading />;
    }
    //if projects are undefined, return informative message
    if (!projects) {
      return <div>No Projects to Display</div>;
    }

    const groupedClientProjects = _.groupBy(projects, 'clientName');

    return Object.entries(groupedClientProjects).map(([key, value]) => {
      const clientsPriorities = getPriorities(value as ProjectPrioritiesDto[]);
      return <ClientDisplayGrid client={key} priorities={clientsPriorities} key={key} />;
    });
  };

  const getPriorities = (clientProjects: ProjectPrioritiesDto[]) => {
    return clientProjects.flatMap(cp => cp.priorities);
  };

  return (
    <>
      <FilterOptions state={filters} setState={setFilters} page={'clients'} />
      {displayClientPriorityGrid()}
    </>
  );
}

export default Client;
